
define('text!views/shop/instore/terms.html',[],function () { return '\r\n<div class="ecard-terms-inner-container">\r\n\r\n\t<h1>Terms and Conditions</h1>\r\n\r\n\t<p class="ecard-terms-content"><%- this.terms %></p>\r\n\r\n\t<button class="btn btn-default btn--pill ecard-terms-button js-ecard-terms-button">Close</button>\r\n\r\n</div>';});

